import { createTeamResourceContext } from './createTeamResourceContext'
import useTeamServicesResources from '../shared/resources/api/v1/admin/docker/useTeamServicesResources'
import { useServiceStatusEvents } from '../shared/websocket'
import useThrottledCallback from '../shared/hooks/useThrottledCallback'

const { Provider: BaseServicesProvider, useHook: useServices, useSafeHook: useServicesSafe } = createTeamResourceContext({
  name: 'Services',
  useResources: useTeamServicesResources,
  responseKey: 'services',
  requestOptions: { limit: 500 },
  lookups: [{ key: 'servicesById', field: 'id' }],
  groupings: [{ key: 'servicesByProjectId', field: 'dockerProjectId' }],
  polling: false,
})

function ServiceStatusEventSubscriber({ children }) {
  const { reload } = useServices()
  const throttledReload = useThrottledCallback(reload)

  useServiceStatusEvents({
    onCreated: throttledReload,
    onUpdated: throttledReload,
  })

  return children
}

function ServicesProvider({ children }) {
  return (
    <BaseServicesProvider>
      <ServiceStatusEventSubscriber>
        {children}
      </ServiceStatusEventSubscriber>
    </BaseServicesProvider>
  )
}

export { ServicesProvider, useServices, useServicesSafe }
